import { render, staticRenderFns } from "./GiftBoxConfirmed.vue?vue&type=template&id=57acffac&scoped=true&"
import script from "./GiftBoxConfirmed.vue?vue&type=script&lang=js&"
export * from "./GiftBoxConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./GiftBoxConfirmed.vue?vue&type=style&index=0&id=57acffac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57acffac",
  null
  
)

export default component.exports